import React, { useEffect, useState } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Table from 'components/Shared/Table'
import { fetchUsersPage } from 'services'
import { columns } from 'components/Users/columns'
import { Set } from 'immutable'
import { useAuth, USER_GROUP_EDIT } from 'context/auth'

export default function SelectMembersDialog ({ isOpen, members, onClose }) {
  const [selectedMembersIds, setSelectedMembersIds] = useState(new Set())
  const { hasAnyPrivileges } = useAuth()

  useEffect(() => setSelectedMembersIds(Set.of(...members.map(member => member.userId))), [members, isOpen])

  const handleDismiss = () => {
    onClose(null)
  }

  const saveChanges = () => {
    onClose(selectedMembersIds)
  }

  const onRowClickHandler = row => {
    const clickedRowId = row.id
    const isSelected = selectedMembersIds.includes(clickedRowId)
    isSelected ?
      setSelectedMembersIds(selectedMembersIds.delete(clickedRowId))
      : setSelectedMembersIds(selectedMembersIds.add(clickedRowId))
  }

  const addButton = {
    label: 'form.selectUsers.save',
    onClick: saveChanges,
    isClickable: hasAnyPrivileges([USER_GROUP_EDIT])
  }

  return (
    <Dialog
      open={isOpen}
      onClose={handleDismiss}
      maxWidth={'xl'}
      fullWidth
    >
      <DialogContent className={'p-0'}>
        <Table title={'form.selectUsers.title'}
               disableTabs
               addButton={addButton}
               fetchData={fetchUsersPage}
               columns={columns}
               tableKey={'selectMembers'}
               onRowClick={onRowClickHandler}
               selection={{
                 selectedRowsIds: selectedMembersIds,
                 onRowsSelect: (ids) => {
                   setSelectedMembersIds(selectedMembersIds.union(ids))
                 },
                 onRowsRemove: (ids) => {
                   setSelectedMembersIds(selectedMembersIds.subtract(ids))
                 }
               }}
        />
      </DialogContent>
    </Dialog>
  )
}
